<div class="tab-divider"></div>

<div class="top-div">
  <ng-container *ngIf="tableData.data?.length; else noDataTemplate">
    <div class="table-title d-flex flex-column justify-content-center ps-3">
      <span class="header-5">{{ tableData.tableHeader }}</span>
    </div>

    <app-zorro-table
      tableId="mappi-overvw"
      [columns]="tableData.columns"
      [data]="tableData.data"
      (handleActions)="handleTableActions($event)"
    ></app-zorro-table>
      <!-- [pageSize]="pageSize" (onModalOpen)="onIconClickEvent($event)" -->

  </ng-container>
  <ng-template #noDataTemplate>
    <app-no-data></app-no-data>
  </ng-template>
</div>
